import { MaskedLines, Reveal } from "@/components/Reveal";
import { renderAccent } from "@/components/RichText";

export default function PageHero({ overline, titleLines, description }) {
  return (
    <section className="relative overflow-hidden pb-16 pt-36 md:pb-24 md:pt-48">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full bg-rose-200/40 blur-[120px]"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -left-32 top-24 h-[360px] w-[360px] rounded-full bg-gold/10 blur-[100px]"
      />
      <div className="relative mx-auto max-w-7xl px-6 md:px-12">
        <Reveal y={14}>
          <span className="inline-flex items-center gap-3 font-accent text-xs uppercase tracking-[0.3em] text-gold-dark">
            <span className="h-px w-8 bg-gold/60" />
            {overline}
          </span>
        </Reveal>
        <MaskedLines
          as="h1"
          delay={0.1}
          lines={titleLines.map((l) => renderAccent(l))}
          className="mt-6 font-serif text-5xl leading-[1.05] tracking-tight text-charcoal-900 sm:text-6xl lg:text-7xl"
        />
        {description && (
          <Reveal delay={0.45}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-muted-foreground md:text-lg">
              {description}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
